'use client';
import { useSearchParams, useRouter } from 'next/navigation';
import { Tabs, TabsList, TabsTrigger } from '@simulmedia/ui-kit';
import { useMemo } from 'react';

type Category = {
  _id: string;
  title: string | null;
};
type ResourceFilterProps = {
  categories: Category[];
};

const ViewAll: Category = { _id: 'View All', title: 'View All' };

export default function ResourceFilter({ categories }: ResourceFilterProps) {
  const categoriesList = useMemo(() => [ViewAll, ...categories], [categories]);
  const { replace } = useRouter();
  const searchParams = useSearchParams();

  const onFilter = (filter: string) => {
    const searchEntries = Array.from(searchParams.entries());
    const params = new URLSearchParams(searchEntries);
    if (filter === ViewAll.title) {
      params.delete('category');
    } else {
      params.set('category', filter);
    }
    replace(`?${params.toString()}`, { scroll: false });
  };

  return (
    <Tabs
      defaultValue={ViewAll.title!}
      className="flex w-full justify-center bg-transparent"
    >
      <TabsList className="tablet:pl-[152px] scrollbar-hide desktop:max-w-desktop relative mt-[-54px] flex w-full justify-start overflow-x-auto rounded-none bg-transparent p-0 pl-6 whitespace-nowrap">
        {categoriesList.map((category) => (
          <TabsTrigger
            data-test={category.title!}
            onClick={() => onFilter(category.title!)}
            key={category._id}
            value={category.title!}
            className="relative flex items-center rounded-[8px] px-4 font-semibold text-white data-[state=active]:bg-[rgba(128,179,255,0.5)] data-[state=active]:text-white data-[state=active]:shadow-none"
          >
            {category.title!}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
